/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';

const IRT_PRIORITY_ID = 1;
const IRT_NON_PRIORITY_ID = 2;
const IRT_SESSION_STORAGE_ID = 'IRT_SESSION_STORAGE_ID';
const IRT_TOUR_MODAL = 'AAMSiteTour';
const getIrtMessages = (state) => state.irtMessages;

export const getHasDataForIrtMessagesModal = createSelector(
  getIrtMessages,
  (irtMessages) => !isEmpty(irtMessages)
);

export const irtMessagesHavePriority = createSelector(
  getIrtMessages,
  getHasDataForIrtMessagesModal,
  (irtMessages, hasDataForIrtMessagesModal) => {
    if (hasDataForIrtMessagesModal) {
      const hasInterceptBeenSeen = Boolean(
        sessionStorage.getItem(IRT_SESSION_STORAGE_ID)
      );
      if (irtMessages[IRT_PRIORITY_ID] && irtMessages[IRT_PRIORITY_ID].length) {
        return (
          Boolean(irtMessages[IRT_PRIORITY_ID].length) && !hasInterceptBeenSeen
        );
      }
    }
    return false;
  }
);

export const getInterceptMessage = createSelector(
  getIrtMessages,
  getHasDataForIrtMessagesModal,
  (irtMessages, hasDataForIrtMessagesModal) => {
    if (hasDataForIrtMessagesModal) {
      if (irtMessages[IRT_PRIORITY_ID] && irtMessages[IRT_PRIORITY_ID].length) {
        return irtMessages[IRT_PRIORITY_ID][0];
      }
      if (
        irtMessages[IRT_NON_PRIORITY_ID] &&
        irtMessages[IRT_NON_PRIORITY_ID].length
      ) {
        return irtMessages[IRT_NON_PRIORITY_ID][0];
      }
    }
    return {};
  }
);

export const getInterceptIsTourModal = createSelector(
  getInterceptMessage,
  (interceptMessage) => {
    return interceptMessage.messageName === IRT_TOUR_MODAL;
  }
);
